import React, { useId, useState } from 'react'
import { Notice } from '../../../../shared/sso-workspace/fleet-page'
import { IconDownload } from '../../../../shared/icon/icon'
import { serverMessage } from '../../../../shared/error/server-message'
import { ErrorReference } from '../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { addDays, dayOf } from '../../../../shared/date/local-time'
import { downloadExport } from './consent-log-api'
import { MAX_EXPORT_DAYS, daysInRange } from './consent-log-words'

// A date range of records (UTC days) as one CSV, saved as content names it
// (consent-log-<from>-<to>.csv). A range over MAX_EXPORT_DAYS is refused
// here, before any request. A file that ends with content's EXPORT
// INCOMPLETE line (a database error after the download began) is still
// saved, and the tab says it must not be relied on.
export const ExportTab = () => {
  const ids = { from: useId(), to: useId() }
  const today = dayOf(Date.now())
  const [from, setFrom] = useState(() => addDays(today, -6))
  const [to, setTo] = useState(today)
  const [busy, setBusy] = useState(false)
  const [incomplete, setIncomplete] = useState('') // the file name of an incomplete download
  const [error, failure, setError] = useErrorLine()

  const days = daysInRange(from, to)
  const problem = !from || !to || days === 0
    ? '"To" must be on or after "From".'
    : days > MAX_EXPORT_DAYS ? `A range is at most ${MAX_EXPORT_DAYS} days; this one is ${days}.` : ''

  const exportCsv = async () => {
    if (problem || busy) return
    setBusy(true)
    setError(null)
    setIncomplete('')
    const filename = `consent-log-${from}-${to}.csv`
    try {
      const result = await downloadExport({ from, to }, filename)
      if (result && result.incomplete) setIncomplete(filename)
    } catch (err) {
      setError(serverMessage(err, "The export couldn't be made."), err)
    }
    setBusy(false)
  }

  return (
    <>
      <div className="ak-filters">
        <div className="ak-filter">
          <label className="sw-label" htmlFor={ids.from}>From</label>
          <input id={ids.from} type="date" className="form-control" value={from} max={to || undefined} onChange={e => setFrom(e.target.value)} />
        </div>
        <div className="ak-filter">
          <label className="sw-label" htmlFor={ids.to}>To</label>
          <input id={ids.to} type="date" className="form-control" value={to} min={from || undefined} onChange={e => setTo(e.target.value)} />
        </div>
        <div className="ak-filter">
          <button type="button" className="btn sw-btn" disabled={!!problem || busy} onClick={exportCsv}><IconDownload className="me-1" />Export CSV</button>
        </div>
      </div>
      <p className="sw-hint">Days are UTC, both included, up to {MAX_EXPORT_DAYS} days.</p>
      {problem && <Notice tone="warn" role="alert">{problem}</Notice>}
      {error && <Notice tone="bad" role="alert">{error}<ErrorReference error={failure} /></Notice>}
      {incomplete && (
        <Notice tone="bad" role="alert">
          {incomplete} is incomplete: the export stopped partway with a database error, and the file ends with an EXPORT INCOMPLETE line.
          It must not be relied on. Export the range again.
        </Notice>
      )}
    </>
  )
}
